module.exports = __webpack_public_path__ + "static/media/art28.610a826a.jpg";